<template>
        <div :class="[
            buttonClasses,
            'group flex items-center p-1.5 rounded-full border transition duration-button-hover ease-in',
        ]">
        <component
            :is="icon"
            :class="iconSize"
            :weight="iconWeight"
            />
        </div>
</template>

<script>


import { Link } from '@inertiajs/vue3'

export default {
    components: {
        Link,
    },

    props: {
        modelClass: {
            type: String,
            required: true,
        },
        iconSize: {
            type: String,
            default: 'size-4',
        },
        iconWeight: {
            type: String,
            default: 'bold'
        },
        invertedColors: {
            type: Boolean,
            default: true
        },
        icon: {
            type: Object,
            deafult: null
        },
    },
    computed: {
        
        buttonClasses() {
            if (this.invertedColors) {
                return [
                    `bg-${this.modelClass}-accent 
                    text-${this.modelClass}
                    border-transparent  
                    hover:bg-${this.modelClass}-hover`]
            }
            return [
                `text-${this.modelClass}-accent 
                border-transparent 
                hover:border-${this.modelClass}-accent`,
            ]
        },
    }
}
</script>